import React, { useEffect, useState } from "react";
import { Text } from "@chakra-ui/react";
import { inIframe, useSessionCtx, usePostMessage, FLOWS, redirectWindowLocation } from "utils";
import usePayPalRedirect from "components/Paypal/usePayPalRedirect";

// used in AddPM flow as an immediate redirect when specified in flowConfig
export const AddPaypalRedirect = ({ onError }) => {
  const { sessionCtx, setFlowState } = useSessionCtx();
  const { flowState } = sessionCtx;
  const { postMessage } = usePostMessage(FLOWS.PAYPAL, sessionCtx?.intCtx);
  const [redirect, setRedirect] = useState();
  const { getPayPalRedirectResponse } = usePayPalRedirect();

  if (redirect) {
    redirectWindowLocation(redirect);
  }

  useEffect(() => {
    const processResponse = (response) => {
      setFlowState("paypal.redirect");
      if (inIframe()) {
        // the widget script is going to handle the redirect
        postMessage(`tilia.${FLOWS.PAYPAL}.redirect`, {
          redirect: response.payload.redirect_uri,
        });
      } else {
        setRedirect(response.payload.redirect_uri);
      }
    };
    const processError = (error) => {
      setFlowState("paypal.error");
      if (onError) onError(error);
      if (inIframe()) {
        postMessage(`tilia.${FLOWS.PAYPAL}.error`, {
          error: error.message || "There was an issue redirecting to PayPal.",
        });
      } else {
        // redirect error?
      }
    };
    const startPaypal = async () => {
      try {
        const response = await getPayPalRedirectResponse();
        processResponse(response);
      } catch (error) {
        processError(error);
      }
    };
    startPaypal();
    // some of the dependencies in this useEffect were causing it to fire multiple times.
    // removing those depencies here since we know they are not expected to change (and I don't want to muck too much with code that's used in other places)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span data-testid="add-paypal-redirect-wrapper">
      {redirect && <span data-testid="add-paypal-redirect"></span>}
      {flowState === "paypal.error" && (
        <Text as="i" fontSize="md" color="tertiaryText">
          There was an error with your request. Please try again.
        </Text>
      )}
    </span>
  );
};
